module.exports = __webpack_public_path__ + "media/dealer/dealerTab3-dfa074c0.jpg";